import JsonRequest from './jsonRequest'
import { create } from 'zustand';

const user = JSON.parse(localStorage.getItem("sign-in-user") || "null")
const permission = JSON.parse(localStorage.getItem("sign-in-permission") || "null")

export type globalState = {
    user: any,
    permission: any,
    requestSignedPayload: string | null,
    navActiveKey: string | null,
    jsonRequest: JsonRequest,
    initSignedPayload: (payload: string) => void
    navActive: (menuKey: string) => void
    signIn: (user: any) => void
    signOut: () => void
    setPermission: (permission: any) => void
    setClient: (jsonRequest: JsonRequest) => void
}

export const useGlobalState = create<globalState>((set, get) => {
    return {
        // 当前用户
        user: user,
        // 当前权限
        permission: permission,
        // 请求的签名载荷
        requestSignedPayload: null,
        // 导航栏当前激活的key
        navActiveKey: null,
        // json请求客户端
        jsonRequest: JsonRequest.tokenClient(user),
        // 初始化激活的payload
        initSignedPayload: (payload: string) => {
            set({ requestSignedPayload: payload })
        },
        // 设置当前活跃的导航项
        navActive: (menuKey: string) => {
            set({ navActiveKey: menuKey })
        },
        // 用户登录
        signIn: (user: any) => {
            set({ user })
        },

        // 用户退出登录
        signOut: () => {
            localStorage.setItem("sign-in-user", "null")
            localStorage.setItem("current-account", "null")
            localStorage.setItem("sign-in-permission", "null")
            set({ user: null, permission: null })
        },

        // 设置当前的权限
        setPermission: (permission: any) => {
            set({ permission })
        },

        // 设置客户端
        setClient: (jsonRequest: JsonRequest) => {
            set({ jsonRequest })
        }
    }
})
